<template lang="html">
  <div class="navbar-item searchbar" :class="{'is-active': active}" @click="activate" v-on-clickaway="deactivate">
    <span class="searchicon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <circle cx="10.5" cy="10.5" r="7.5"/>
        <line x1="21" y1="21" x2="15.8" y2="15.8"/>
      </svg>
    </span>

    <form class="field" action="#" method="GET" @submit.prevent="load">
      <p class="control">
        <input
          ref="input"
          class="input"
          type="search"
          :placeholder="$t('What do you want to eat?')"
          v-model="search"
          @blur="deactivate"
          @keydown.enter="load"
        >
      </p>
      <div class="dropdown-menu" v-if="showPreview">
        <div class="dropdown-content">
          <template v-for="(result, index) in preview">
            <a class="dropdown-item" :key="index" :href="result.item.url" v-if="result.item.url">
              <span>{{ result.item.name }}</span>
            </a>
          </template>
          <a :href="resultUrl" class="dropdown-item has-text-centered" v-if="preview.length > 1">
            <div class="button is-primary">{{ $t('show all') }}</div>
          </a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'

import { directive as onClickaway } from 'vue-clickaway'

export default {
  props: {
    value: {type: String, default: window.__INIT_DATA.text || ''},
    language: {type: String, default: window.__INIT_DATA.lang}
  },

  directives: {
    onClickaway
  },

  data(){
    return {
      active: false,
      search: this.value,
      preview: []
    }
  },

  watch: {
    search(value){
      clearTimeout(this.timeout)
      if(value && value.length > 1){
        this.timeout = setTimeout(() => this.loadPreview(), 300)
      }else{
        this.preview = []
      }
    }
  },


  computed: {
    showPreview(){
      return this.active && this.preview.length > 0
    },

    resultUrl(){
      if(!this.search) return `/${this.language}/all`
      return `/${this.language}/search/${encodeURIComponent(this.search)}`
    }
  },


  methods: {
    activate(){
      this.active = true
      this.$refs.input.focus()
    },

    deactivate(){
      setTimeout(() => {
        this.active = false
        this.$refs.input.blur()
      }, 400)
    },

    load(){
      if(this.preview.length === 1){
        window.location.href = this.preview[0].item.url
        return
      }
      window.location.href = this.resultUrl
    },

    loadPreview(){
      clearTimeout(this.timeout)
      return axios.get(`/${this.language}/search/${encodeURIComponent(this.search)}/1.json`)
      .then(result => {
        this.preview = result.data.search.nodes.splice(0, 5)
      })
    }
  }
}
</script>

<i18n>
{
  "de_at": {
    "What do you want to eat?": "Was willst du kochen?"
  },
  "cs": {
    "What do you want to eat?": "Co chcete vařit?"
  },
  "hu": {
    "What do you want to eat?": "Mit akar főzni?"
  },
  "fr": {
    "What do you want to eat?": "Que voulez-vous cuisiner??"
  }
}
</i18n>



// WEBPACK FOOTER //
// src/components/PageSearch.vue